var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubtitle = function SvgSubtitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 20V6.1H3.65V3.65H16V6.1h-4.725V20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.01 20v-7.784h-2.646v-1.372h6.916v1.372h-2.646V20z"
  })));
};
export default SvgSubtitle;